import { render, staticRenderFns } from "./CardPlaceholder.vue?vue&type=template&id=99796d40"
import script from "./CardPlaceholder.vue?vue&type=script&lang=js"
export * from "./CardPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports